/* eslint-disable no-irregular-whitespace */
import { concat } from "../concat"

export const getFullName = (surname: string, name: string, isKanji?: boolean) =>
  isKanji
    ? surname || name
      ? `${concat(surname)}　${concat(name)}`
      : ""
    : `${concat(surname)} ${concat(name)}`.trim()
